var exports = {
  "i": "xaf9ae18d--961bc7--wrapper",
};

module.exports = exports;
